export const DIALER_NUMBER_LIMIT = 15;

export const dialerNavigationStates = {
  contacts: 'contacts',
  dialer: 'dialer',
  settings: 'settings',
} as const;
